import { render, staticRenderFns } from "./WorkDepartment.vue?vue&type=template&id=18884870&scoped=true&"
import script from "./WorkDepartment.vue?vue&type=script&lang=js&"
export * from "./WorkDepartment.vue?vue&type=script&lang=js&"
import style0 from "./WorkDepartment.vue?vue&type=style&index=0&id=18884870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18884870",
  null
  
)

export default component.exports